import { FC } from 'react'
import styles from 'components/features/coaching/advisorPublicPage/AdvisorHeader/AdvisorHeader.styl'
import { Advisor } from 'components/features/coaching/advisor/types/advisor'
import { AdvisorGrades } from 'components/features/coaching/advisor/AdvisorGrades/AdvisorGrades'
import { AdvisorAvatar } from 'components/features/coaching/advisor/AdvisorAvatar/AdvisorAvatar'
import { AdvisorRating } from 'components/features/coaching/advisor/AdvisorRating/AdvisorRating'

type AdvisorHeaderProps = {
  advisor: Advisor
}
export const AdvisorHeader: FC<AdvisorHeaderProps> = (props) => {
  const { advisor } = props

  return (
    <div className={ styles.advisorHeader }>
      <div className={ styles.column }>
        <div className={ styles.left }>
          <div className={ styles.avatar }>
            <AdvisorAvatar uid={ advisor.uid } type='auxBorderWidth' />
          </div>
        </div>
        <div className={ styles.right }>
          <div className={ styles.name }>
            { advisor.name }
          </div>
          <div className={ styles.certificates }>
            <AdvisorGrades advisor={ advisor } />
          </div>
          <div className={ styles.rating }>
            <AdvisorRating advisor={ advisor } />
          </div>
        </div>

      </div>
    </div>
  )
}
